module.exports = __webpack_public_path__ + "img/Intro-VoiceControl.6734038b.png";